import { Announced } from '@fluentui/react/lib/Announced';
import * as React from 'react';
import { useCallback, useContext, useMemo, useState } from 'react';
import { AnnounceType, IAnnouncerContextProps, IAnnouncerProps, IAnnouncerState } from './AnnouncerContext.types';

export const AnnouncerContext = React.createContext<IAnnouncerContextProps>({
  announce: () => {
    return;
  }
});

export const AnnouncerContextProvider: React.FC<IAnnouncerProps> = ({
  children
}) => {
  const [announceState, setAnnounceState] = useState<IAnnouncerState>({
    message: undefined,
    announceType: AnnounceType.Polite
  });

  const { message, announceType } = announceState;

  const announce = useCallback(
    (newMessage: string, newAnnounceType?: AnnounceType) => {
      setAnnounceState({
        message: newMessage,
        announceType: newAnnounceType || AnnounceType.Polite
      });

      // Currently we don't flip the message to empty as it was causing a bug w/ duplicate announcements
      // As a result, we will not announce consecutive announcements that are the same
    },
    []
  );
  const providerValue = useMemo(() => ({ announce }), [announce]);

  return (
    <AnnouncerContext.Provider value={providerValue}>
      {children}
      {announceType && <Announced message={message} aria-live={announceType} />}
    </AnnouncerContext.Provider>
  );
};

export const useAnnouncerContext = () => useContext(AnnouncerContext);
